/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SavedView {
    getFixupPrototypeFunction() { return SavedView.fixupPrototype; }

    static newInstance(model: Partial<SavedView>): SavedView {
        let obj = Object.assign(new SavedView(), model);
        SavedView.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SavedView>): SavedView {
        if (!model) return null;
        return SavedView.newInstance(<SavedView> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SavedView) {
        if (!obj) return;

        models.SavedView.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SavedView): boolean {
        Object.setPrototypeOf(obj, SavedView.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.updated_at === "string") {
            this.updated_at = new Date(<string><any>this.updated_at);
        }
        if (this.view) {
            models.ViewState.fixupPrototype(this.view);
        }
    }

    name: string;

    roles: Array<string>;

    view: models.ViewState;

    updated_at: Date;

}
